import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=781d9d5a"
import script from "./academy.vue?vue&type=script&lang=ts"
export * from "./academy.vue?vue&type=script&lang=ts"
import style0 from "./academy.vue?vue&type=style&index=0&id=781d9d5a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports